export interface EventOptions {
  category?: string;
  name: string;
}

export const eventsRepository = {
  CONSENT_READY: {
    category: "[AdEngine OptIn]",
    name: "set opt in",
  },
  CONSENT_UPDATE: {
    category: "[AdEngine OptIn]",
    name: "update opt in",
  },
  UPDATE_USP_SIGNAL: {
    category: "[IdentityEngine]",
    name: "Update USP Signal",
  },
  IDENTITY_READY: {
    category: "[IdentityEngine]",
    name: "Identity ready",
  },
  SEND_ONETRUST_EVENTS: {
    category: "[IdentityEngine]",
    name: "Send OneTrust events",
  },
  IDENTITY_PARTNER_DATA_OBTAINED: {
    category: "[AdEngine]",
    name: "Identity partner data obtained",
  },
  AGE_GATE_DATA: {
    name: "Age gate result",
    category: "[Identity]",
  },
  PAGE_CHANGED: {
    name: "Page changed",
    category: "[Platform]",
  },
  INSTANT_CONFIG_CACHE_READY: {
    category: "[AdEngine]",
    name: "Instant Config cache ready",
  },

  // Partners
  AUDIGENT_SEGMENT_LIBRARY_LOADED: {
    name: "Audigent segment library loaded",
  },
  AUDIGENT_MATCHES_LIBRARY_LOADED: {
    name: "Audigent matches library loaded",
  },
  AUDIGENT_SEGMENTS_READY: {
    name: "Audigent segments ready",
  },
  EYEOTA_STARTED: {
    name: "Eyeota started",
  },
  EYEOTA_FAILED: {
    name: "Eyeota loading failed",
  },
  LIVE_CONNECT_STARTED: {
    name: "LiveConnect started",
  },
  LIVE_CONNECT_CACHED: {
    name: "LiveConnect data cached",
  },
  LIVE_CONNECT_RESPONDED_UUID: {
    name: "LiveConnect responded with UUID",
  },
} as const satisfies Dictionary<EventOptions>;
